import gridCss from '../../core/utils/Grid.js';
import styles from './InputField.module.scss';
import RotuloSeplag from '../rotuloSeplag/RotuloSeplag.jsx';
import React from 'react';

const colClasseCss = (cols) => {
    let classeCss = gridCss(cols ?? '12');
    return classeCss;
};

const InputField = ({
    afterButton = null,
    infoMessage,
    horizontal,
    className,
    formController,
    ...props
}) => {
    const isFormFieldValid = (name) => !!props.formik.errors[name];
    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && <small className="p-error">{props.formik.errors[name]}</small>
        );
    };

    let input = {};
    if (formController) {
        input = formController.inputs.find((input) => input?.name === props.id);
    }

    return (
        <>
            <div className={`${colClasseCss(props.cols)} ${className ?? ''}`}>
                <RotuloSeplag
                    afterButton={afterButton}
                    infoMessage={infoMessage}
                    nome={`${props?.label ?? input?.label}`}
                    obrigatorio={
                        input?.form?.validate?.hasOwnProperty('required')
                            ? input?.form?.validate?.required ?? false
                            : props.required
                    }
                    horizontal={horizontal}
                    className={`${styles.inputFieldset}`}
                >
                    {React.cloneElement(props.children, {
                        ...props.children?.props,
                        className: { 'p-invalid': isFormFieldValid(props.id) },
                        name: props.children?.name ?? props.id,
                    })}
                    {!horizontal && getFormErrorMessage(props.id)}
                </RotuloSeplag>
            </div>
            {horizontal && getFormErrorMessage(props.id)}
        </>
    );
};

export default InputField;
